export default "__VITE_ASSET__Ci1A0iM8__"